(function ($, Drupal, drupalSettings, GMaps) {
  'use strict';

  Drupal.behaviors.myTripMap = {
    removeFromMytrip: function (id) {
      var slickIndex = $('.view-id-mytrip .node--type-article.node--view-mode-teaser').filter('[data-entity-id="' + id + '"]').parent().attr('data-slick-index');
      var partnerRow = $('.view-id-mytrip .node--type-partner').filter('[data-entity-id="' + id + '"]');
      var articleRow = $('.view-id-mytrip .node--type-article').find('[data-entity-id="' + id + '"]');
      var trailSlickIndex = $('.view-id-mytrip .node--type-trail.node--view-mode-featured').filter('[data-entity-id="' + id + '"]').parent().attr('data-slick-index');

      if (partnerRow.length) {
        $('.view-id-mytrip .node--type-partner').filter('[data-entity-id="' + id + '"]').parent().remove();
        Drupal.behaviors.myTripMap.setMarkers(true);
      }

      if (trailSlickIndex) {
        $.when($('.view-id-mytrip.view-display-id-trails .view-content').slick('unslick')).then(function (data, textStatus, jqXHR) {
          $('.view-id-mytrip .node--type-trail').filter('[data-entity-id="' + id + '"]').parent().remove();
          if (!$('.view-id-mytrip.view-display-id-trails .view-content').children().length) {
            location.reload();
          }
          else {
            Drupal.behaviors.slider.initTrailSlider();
          }
        });
      }

      if (slickIndex) {
        $.when($('.view-id-mytrip.view-display-id-articles .view-content').slick('unslick')).then(function (data, textStatus, jqXHR) {
          $('.view-id-mytrip .node--type-article').filter('[data-entity-id="' + id + '"]').parent().remove();
          Drupal.behaviors.slider.initMyTripArticleSlider();
        });
      }
      else if (articleRow.length) {
        $('.view-id-mytrip .node--type-article').filter('[data-entity-id="' + id + '"]').parent().remove();
        if (!$('.view-id-mytrip.view-display-id-articles .view-content').children().length) {
          location.reload();
        }
      }
    },
    selectListingItem: function (id) {
      var v = $('.view-id-mytrip, .view-id-sharedtrip');
      var partners = v.filter('.view-display-id-partners');

      partners.find('.map-listing').filter('[data-entity-id="' + id + '"]').addClass('selected');
      partners.find('.map-listing').not('[data-entity-id="' + id + '"]').removeClass('selected');

      var container = partners.find('.view-content');
      var elem = container.find('.selected');

      container.animate({
        scrollTop: container.scrollTop() - container.offset().top + elem.offset().top
      }, 1000);
      this.setMarkers(false);
    },
    setMarkers: function (rebound) {
      var v = $('.view-id-mytrip, .view-id-sharedtrip');
      var partners = v.filter('.view-display-id-partners');

      drupalSettings.mytrip_map.removeMarkers();

      var markers = [];
      partners.find('.map-listing').not('.hidden').each(function () {
        var marker = {
          id: $(this).data('entityId'),
          latitude: $(this).attr('listing-lat'),
          longitude: $(this).attr('listing-lon'),
          selected: $(this).hasClass('selected')
        };
        if (marker.latitude && marker.longitude) {
          markers.push(marker);
        }
      });

      if (markers.length) {
        var bounds = [];
        // Load map markers.
        markers.forEach(function (arrayItem) {
          var latlng = new google.maps.LatLng(arrayItem.latitude, arrayItem.longitude);
          bounds.push(latlng);
          var icon = arrayItem.selected ? drupalSettings.tnv_google_maps.settings.mytrip_pin : drupalSettings.tnv_google_maps.settings.default_pin;
          drupalSettings.mytrip_map.addMarker({
            lat: arrayItem.latitude,
            lng: arrayItem.longitude,
            icon: icon,
            zIndex: arrayItem.selected ? 100 : 1,
            click: function (e) {
              Drupal.behaviors.myTripMap.selectListingItem(arrayItem.id);
            }
          });
        });
        if (rebound === true) {
          drupalSettings.mytrip_map.fitLatLngBounds(bounds);
        }
      }
      else {
        location.reload();
      }

    },
    loadMap: function (target) {
      if (target.jquery) {
        target = target[0];
      }

      drupalSettings.mytrip_map = new GMaps({
        div: target,
        lat: 35.5175,
        lng: -86.5804,
        zoom: 7,
        disableDefaultUI: false,
        scaleControl: true,
        scrollwheel: false
      });

      drupalSettings.mytrip_map.addStyle({
        styledMapName: 'Styled Map',
        styles: JSON.parse(drupalSettings.tnv_google_maps.settings.style),
        mapTypeId: 'map_style'
      });
      drupalSettings.mytrip_map.setStyle('map_style');

      this.setMarkers(true);

    },
    attach: function () {
      var parent = this;


      var v = $('.view-id-mytrip, .view-id-sharedtrip');
      var partners = v.filter('.view-display-id-partners');

      if (partners.find('.map-listing').length < 1) {
        return;
      }

      var selected = partners.filter(':not(.mytrip-map-processed)');
      if (selected.length) {
        selected.addClass('mytrip-map-processed').each(function () {
          var map_markers = [];
          $(this).find('.map-listing').each(function () {

            $(this).on('click', function (e) {
              Drupal.behaviors.myTripMap.selectListingItem($(this).data('entityId'));
            });

            var marker = {
              id: $(this).data('entityId'),
              latitude: $(this).attr('listing-lat'),
              longitude: $(this).attr('listing-lon')
            };
            if (marker.latitude && marker.longitude) {
              map_markers.push(marker);
            }
          });
          $('<div class="view-map">').appendTo(this);
          var map_target = $(this).find('.view-map');
          parent.loadMap(map_target, map_markers);
        });
      }
    }
  };
})(jQuery, Drupal, drupalSettings, GMaps);
